import { TicketAssignCheckbox } from './TicketAssignCheckbox';

export default TicketAssignCheckbox;
